import { toast } from "@/components/ui/use-toast";
import { useExportStoreAccessMutation } from "@/services/store-access-query";
import { downloadFromBlob } from "@/utils/download-blob";

import { useStoreAccessFilterState } from "../filter/hooks/filterState";

import { EXPORT_EXCEL_MESSAGES } from "./messages";
import { generateTimestampFileName } from "./utils";

export const useExportExcel = () => {
  const [exportStoreAccess, { isLoading }] = useExportStoreAccessMutation();
  const { storeCode, activeTab, users, operators } =
    useStoreAccessFilterState();
  const activeFilters = activeTab === "users" ? users : operators;

  const handleExport = async (analystName: string) => {
    if (!storeCode) {
      toast(EXPORT_EXCEL_MESSAGES.NO_STORE);
      return;
    }

    try {
      const blob = await exportStoreAccess({
        storeCode,
        entity: activeTab,
        search: activeFilters.search || undefined,
        code: activeFilters.code || undefined,
        classification: activeFilters.classification || undefined,
        cpfFilter: activeFilters.cpfFilter || "valid",
        blocked: activeFilters.blocked ?? undefined,
        sortBy: activeFilters.sortBy || undefined,
        sortOrder: activeFilters.sortOrder || undefined,
        analystName,
      }).unwrap();

      const entityLabel = activeTab === "operators" ? "operadores" : "usuarios";
      const fileName = generateTimestampFileName(
        `consulta_acessos_${entityLabel}_loja_${storeCode}`,
        "xlsx",
      );
      downloadFromBlob(blob, fileName);

      toast(EXPORT_EXCEL_MESSAGES.SUCCESS);
    } catch (error) {
      toast(EXPORT_EXCEL_MESSAGES.ERROR);
      console.error("Erro ao exportar:", error);
    }
  };

  return { handleExport, isLoading };
};
